import React, { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

const TermOfUse = () => {
  const { t } = useTranslation();




  return (
        <div className="terms-page-container" style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
      
            <h1>{t('term-of-use.title')}</h1>
            <p>{t('term-of-use.last-updated')}</p>
            
            <section className="terms-section">
                <h2>{t('term-of-use.section1.title')}</h2>
                <p>{t('term-of-use.section1.content-1')}</p>
                <p>{t('term-of-use.section1.content-2')}</p>
                <p>{t('term-of-use.section1.content-3')}</p>
                <p>{t('term-of-use.section1.content-4')}</p>
                <p>{t('term-of-use.section1.content-5')}</p>
                <p>{t('term-of-use.section1.content-6')}</p>
            </section>
            <section className="terms-section">
                <h2>{t('term-of-use.section2.title')}</h2>
                <p>{t('term-of-use.section2.content-1')}</p>
                <p>{t('term-of-use.section2.content-2')}</p>
                <p>{t('term-of-use.section2.content-3')}</p>
                <p>{t('term-of-use.section2.content-4')}</p>
                <p>{t('term-of-use.section2.content-5')}</p>
                <p>{t('term-of-use.section2.content-6')}</p>
                <p>{t('term-of-use.section2.content-7')}</p>
            </section>  
            <section className="terms-section">
                <h2>{t('term-of-use.section3.title')}</h2>
                <p>{t('term-of-use.section3.content-1')}</p>
                <p>{t('term-of-use.section3.content-2')}</p>
                <p>{t('term-of-use.section3.content-2-1')}</p>
                <p>{t('term-of-use.section3.content-2-2')}</p>
                <p>{t('term-of-use.section3.content-2-3')}</p>
                <p>{t('term-of-use.section3.content-2-4')}</p>
                <p>{t('term-of-use.section3.content-2-5')}</p>
                <p>{t('term-of-use.section3.content-2-6')}</p>
                <p>{t('term-of-use.section3.content-3')}</p>
            </section>
            <section className="terms-section">
                <h2>{t('term-of-use.section4.title')}</h2>
                <p>{t('term-of-use.section4.content-1')}</p>
                <p>{t('term-of-use.section4.content-2')}</p>
                <p>{t('term-of-use.section4.content-3')}</p>
                <p>{t('term-of-use.section4.content-4')}</p>
            </section>
            <section className="terms-section">
                <h2>{t('term-of-use.section5.title')}</h2>
                <p>{t('term-of-use.section5.content-1')}</p>
                <p>{t('term-of-use.section5.content-2')}</p>
            </section>
            <section className="terms-section">
                <h2>{t('term-of-use.section6.title')}</h2>
                <p>{t('term-of-use.section6.content-1')}</p>
                <p>{t('term-of-use.section6.content-2')}</p>
                <p>{t('term-of-use.section6.content-3')}</p>
                <p>{t('term-of-use.section6.content-4')}</p>
            </section>
            <section className="terms-section">
                <h2>{t('term-of-use.section7.title')}</h2>
                <p>{t('term-of-use.section7.content-1')}</p>
            </section>
            <section className="terms-section">
                <h2>{t('term-of-use.section8.title')}</h2>
                <p>{t('term-of-use.section8.content-1')}</p>
            </section>
            <section className="terms-section">
                <h2>{t('term-of-use.section9.title')}</h2>
                <p>{t('term-of-use.section9.content-1')}</p>
                <p>{t('term-of-use.section9.content-2')}</p>
                <p>{t('term-of-use.section9.content-3')}</p>
                <p>{t('term-of-use.section9.content-4')}</p>
                <p>{t('term-of-use.section9.content-5')}</p>
                <p>{t('term-of-use.section9.content-6')}</p>
            </section>




        </div>
  );
};

export default TermOfUse;
